import React from "react";
import { Modal } from "react-bootstrap";

interface StatusModalProps {
  onSuccess?: (success: any) => void;
  onClose: (success: any) => void;
  shouldShow: boolean;
  message: any;
  type: number; // 1 for pick-status-message, 2 for app-redirection, 3 for guest-save
}

export default function StatusModal({ onSuccess, onClose, shouldShow, message, type }: StatusModalProps) {
  return (
    <React.Fragment>
      <Modal show={shouldShow} backdrop="static" keyboard={false} centered contentClassName="custom-modal">
        {type == 3 && (
          <Modal.Header>
            <h2 className="modal-header-text">Save Your Vote</h2>
            <button type="button" className="btn-close" onClick={() => onClose(true)}></button>
          </Modal.Header>
        )}
        <Modal.Body>
          <div className="modal-body">
            <h4 className="rider-name-content">{message}</h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button type="button" className="rkmd-btn btn-lg btn-black ripple-effect w-100 mt-3" onClick={onClose}>
              {type == 2 ? "Stay" : type == 3 ? "Skip" : "Close"}
            </button>
          </div>
          {[2, 3].includes(type) && (
            <div className="btn-wrap mb-3">
              <button type="button" className="rkmd-btn btn-lg btn-red ripple-effect w-100 mt-3" onClick={onSuccess}>
                {type == 2 ? "Leave" : "Skip"}
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
